import "./games.css"
import {useEffect, useLayoutEffect, useRef, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import _ from "lodash";
import {Storage} from "../../services/localstorege.service";
import {modalServiceSubject} from "../../services/modal.service";
import {env} from "../../constants/global.vars";
import {auth, authSubject} from "../../store/auth.store";
import paths from "../../paths";
import Loading from "../../shared/loading";
import iconHelp from "../../assets/feather/help-circle.svg";
import iconBack from "../../assets/feather/chevron-left.svg";
import iconFullscreen from "../../assets/feather/maximize-2.svg";
import iconExitFullscreen from "../../assets/feather/minimize-2.svg";
import logo from "../../assets/img/logo.png";
import {ApiService} from "../../lib/http.service";

const ALTENAR_VENDOR = 10;

const genericError = 'Beklenmeyen bir hata gerçekleşti, lütfen daha sonra tekrar deneyin.';

export const gameSlug = (game: any) => String(game?.code ?? "").replaceAll("_", "-");

export const loadGames = async (): Promise<any[]> => {
    const response: any = await new ApiService().start("get", env.api + "/games/api/list-game/", null, false)
    if (!response || !response.status) {
        throw new Error(response?.error ?? genericError);
    }

    const games = _.orderBy(response.data ?? [], ["ordering"], ["asc"]);
    Storage.set("games", games, 10 * 60 * 1000);
    return games;
}

export const Games = () => {
    const navigate = useNavigate();
    const [state, setState] = useState<{
        loading: boolean;
        error: string | null;
        data: any[];
    }>({
        loading: true,
        error: null,
        data: [],
    })

    useEffect(() => {
        loadGames().then((games: any[]) => {
            setState({loading: false, error: null, data: games})
        }).catch((e: any) => {
            console.error(e)
            setState({loading: false, error: genericError, data: []})
        })
    }, [])

    const openTutorialModal = (game: any) => {
        modalServiceSubject.next({
            case: "info",
            title: `${game.name} Nasıl Oynanır?`,
            width: 420,
            innerHtml: true,
            content: String(game.tutorial).replaceAll("\n", "<br/>"),
            confirm: {
                cancel: {
                    label: "Kapat",
                },
            },
        });
    }

    return (
        <div className={"games-page"}>
            <div className={"container"}>
                {state.loading && (
                    <div className="row justify-content-center">
                        <div className="col-auto">
                            <Loading/>
                        </div>
                    </div>
                )}

                {!state.loading && state.error && (
                    <div className={"games-message"}>{state.error}</div>
                )}

                {!state.loading && !state.error && state.data.length === 0 && (
                    <div className={"games-message"}>Şu anda oynayabileceğiniz bir oyun bulunmuyor.</div>
                )}

                {!state.loading && !state.error && state.data.length > 0 && (
                    <div className={"row"}>
                        {state.data.map((game: any) => {
                            return (
                                <div key={`game-${game.id}`} className={"col-6 col-md-4 col-lg-3 p-2"}>
                                    <div className={`game-card ${game.is_active ? '' : 'is-disabled'}`}
                                         onClick={() => game.is_active && navigate(`${paths.games.url}/${gameSlug(game)}`)}>
                                        <img className={`game-img ${game.image ? '' : 'is-placeholder'}`}
                                             src={game.image ? env.media + game.image : logo}
                                             alt={game.name}/>
                                        {game.tutorial && (
                                            <button className={"game-help"} aria-label={"Nasıl Oynanır?"}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        openTutorialModal(game);
                                                    }}>
                                                <img src={iconHelp} alt={""}/>
                                            </button>
                                        )}
                                        <span className={"game-play"}>{game.is_active ? 'Hemen Oyna' : 'Çok Yakında'}</span>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                )}
            </div>
        </div>
    )
}

export const GamePlayer = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [state, setState] = useState<{
        loading: boolean;
        game: any;
    }>({
        loading: true,
        game: null,
    })
    const [fullscreen, setFullscreen] = useState(false);
    const stageRef = useRef<HTMLDivElement>(null);
    const frameRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        loadGames().then((games: any[]) => {
            if (!games || games.length === 0) {
                // FIXME: PRODDA KALKACAK PROD ÖNCESİ TEST EDİLEBİLMESİ İÇİN KONDU
                const _games = [
                    {
                        "id": 98,
                        "vendor": 8,
                        "name": "D\u00fc\u015fmeden Kazan",
                        "code": "dusmeden-kazan",
                        "ordering": 1,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:06.814",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "437",
                        "category_id": null
                    },
                    {
                        "id": 101,
                        "vendor": 8,
                        "name": "Kazan\u00e7 Treni",
                        "code": "kazanc-treni",
                        "ordering": 2,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:06.875",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "440",
                        "category_id": null
                    },
                    {
                        "id": 104,
                        "vendor": 8,
                        "name": "\u015eans U\u00e7a\u011f\u0131",
                        "code": "sans-ucag",
                        "ordering": 3,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:06.936",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "506",
                        "category_id": null
                    },
                    {
                        "id": 107,
                        "vendor": 8,
                        "name": "Ra'n\u0131n Gizemi",
                        "code": "rann-gizemi",
                        "ordering": 4,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:07.001",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "481",
                        "category_id": null
                    },
                    {
                        "id": 110,
                        "vendor": 8,
                        "name": "Plinko Partisi",
                        "code": "plinko-partisi",
                        "ordering": 5,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:07.065",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "461",
                        "category_id": null
                    },
                    {
                        "id": 113,
                        "vendor": 8,
                        "name": "Plinko Terazisi",
                        "code": "plinko-terazisi",
                        "ordering": 6,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:07.129",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "467",
                        "category_id": null
                    },
                    {
                        "id": 116,
                        "vendor": 8,
                        "name": "Maya Hazineleri",
                        "code": "maya-hazineleri",
                        "ordering": 7,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:07.192",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "435",
                        "category_id": null
                    },
                    {
                        "id": 119,
                        "vendor": 8,
                        "name": "Pinyata Partisi",
                        "code": "pinyata-partisi",
                        "ordering": 8,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:07.255",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "453",
                        "category_id": null
                    },
                    {
                        "id": 122,
                        "vendor": 8,
                        "name": "Harika Ganimet Avc\u0131s\u0131",
                        "code": "harika-ganimet-avcs",
                        "ordering": 9,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:07.318",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "475",
                        "category_id": null
                    },
                    {
                        "id": 125,
                        "vendor": 8,
                        "name": "B\u00fcy\u00fck M\u00fccevher Avc\u0131s\u0131",
                        "code": "buyuk-mucevher-avcs",
                        "ordering": 10,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:07.383",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "477",
                        "category_id": null
                    },
                    {
                        "id": 128,
                        "vendor": 8,
                        "name": "Hazineler Denizi",
                        "code": "hazineler-denizi",
                        "ordering": 11,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:07.448",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "425",
                        "category_id": null
                    },
                    {
                        "id": 131,
                        "vendor": 8,
                        "name": "Kan\u0131t Pe\u015finde",
                        "code": "kant-pesinde",
                        "ordering": 12,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:07.509",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "436",
                        "category_id": null
                    },
                    {
                        "id": 134,
                        "vendor": 8,
                        "name": "B\u00fcy\u00fck Ganimet Avc\u0131s\u0131",
                        "code": "buyuk-ganimet-avcs",
                        "ordering": 13,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:07.574",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "482",
                        "category_id": null
                    },
                    {
                        "id": 137,
                        "vendor": 8,
                        "name": "Harika M\u00fccevher Avc\u0131s\u0131",
                        "code": "harika-mucevher-avcs",
                        "ordering": 14,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:07.640",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "433",
                        "category_id": null
                    },
                    {
                        "id": 140,
                        "vendor": 8,
                        "name": "Ormanlar Kral\u0131",
                        "code": "ormanlar-kral",
                        "ordering": 15,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:07.704",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "441",
                        "category_id": null
                    },
                    {
                        "id": 143,
                        "vendor": 8,
                        "name": "Efsane M\u00fccevher Avc\u0131s\u0131",
                        "code": "efsane-mucevher-avcs",
                        "ordering": 16,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:07.768",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "478",
                        "category_id": null
                    },
                    {
                        "id": 146,
                        "vendor": 8,
                        "name": "Efsane Define Avc\u0131s\u0131",
                        "code": "efsane-define-avcs",
                        "ordering": 17,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:07.830",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "505",
                        "category_id": null
                    },
                    {
                        "id": 149,
                        "vendor": 8,
                        "name": "\u015eansl\u0131 Yoncalar",
                        "code": "sansl-yoncalar",
                        "ordering": 18,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:07.892",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "439",
                        "category_id": null
                    },
                    {
                        "id": 152,
                        "vendor": 8,
                        "name": "Amazon Hazineleri",
                        "code": "amazon-hazineleri",
                        "ordering": 19,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:07.957",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "427",
                        "category_id": null
                    },
                    {
                        "id": 155,
                        "vendor": 8,
                        "name": "Define Avc\u0131s\u0131",
                        "code": "define-avcs",
                        "ordering": 20,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:08.021",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "503",
                        "category_id": null
                    },
                    {
                        "id": 158,
                        "vendor": 8,
                        "name": "\u015eans G\u00f6l\u00fc Mega",
                        "code": "sans-golu-mega",
                        "ordering": 21,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:08.081",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "537",
                        "category_id": null
                    },
                    {
                        "id": 161,
                        "vendor": 8,
                        "name": "\u015eansl\u0131 \u015eapkalar",
                        "code": "sansl-sapkalar",
                        "ordering": 22,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:08.143",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "448",
                        "category_id": null
                    },
                    {
                        "id": 164,
                        "vendor": 8,
                        "name": "\u0130hti\u015faml\u0131 Elmaslar",
                        "code": "ihtisaml-elmaslar",
                        "ordering": 23,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:08.208",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "420",
                        "category_id": null
                    },
                    {
                        "id": 167,
                        "vendor": 8,
                        "name": "\u015eeker F\u0131rt\u0131nas\u0131",
                        "code": "seker-frtnas",
                        "ordering": 24,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:08.269",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "426",
                        "category_id": null
                    },
                    {
                        "id": 170,
                        "vendor": 8,
                        "name": "Muz Demeti",
                        "code": "muz-demeti",
                        "ordering": 25,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:08.331",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "424",
                        "category_id": null
                    },
                    {
                        "id": 173,
                        "vendor": 8,
                        "name": "P\u0131rlantalar",
                        "code": "prlantalar",
                        "ordering": 26,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:08.390",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "445",
                        "category_id": null
                    },
                    {
                        "id": 176,
                        "vendor": 8,
                        "name": "Hayalet Av\u0131",
                        "code": "hayalet-av",
                        "ordering": 27,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:08.450",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "462",
                        "category_id": null
                    },
                    {
                        "id": 179,
                        "vendor": 8,
                        "name": "Efsane Ganimet Avc\u0131s\u0131",
                        "code": "efsane-ganimet-avcs",
                        "ordering": 28,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:08.511",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "484",
                        "category_id": null
                    },
                    {
                        "id": 182,
                        "vendor": 8,
                        "name": "\u015eansl\u0131 Kuzu",
                        "code": "sansl-kuzu",
                        "ordering": 29,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:08.570",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "548",
                        "category_id": null
                    },
                    {
                        "id": 185,
                        "vendor": 8,
                        "name": "B\u00fcy\u00fck Define Avc\u0131s\u0131",
                        "code": "buyuk-define-avcs",
                        "ordering": 30,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:08.629",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "504",
                        "category_id": null
                    },
                    {
                        "id": 188,
                        "vendor": 8,
                        "name": "Duble Kahve",
                        "code": "duble-kahve",
                        "ordering": 31,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:08.689",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "466",
                        "category_id": null
                    },
                    {
                        "id": 191,
                        "vendor": 8,
                        "name": "Kasa Avc\u0131s\u0131",
                        "code": "kasa-avcs",
                        "ordering": 32,
                        "image": "",
                        "gif": "",
                        "status": 0,
                        "is_active": 1,
                        "create_date": "2026-09-14T17:33:08.749",
                        "additional_id": null,
                        "description": null,
                        "tutorial": null,
                        "application_code": "428",
                        "category_id": null
                    }
                ];
                setState({loading: false, game: _games.find((game: any) => gameSlug(game) === params.subpage) ?? null})
                return;
            }

            setState({loading: false, game: games.find((game: any) => gameSlug(game) === params.subpage) ?? null})
        }).catch((e: any) => {
            console.error(e)
            setState({loading: false, game: null})
        })
    }, [params.subpage])

    useLayoutEffect(() => {
        if (state.game?.vendor !== ALTENAR_VENDOR) {
            return;
        }

        const frameWindow: any = frameRef.current?.contentWindow;
        const authSubscription = authSubject.subscribe((res: any) => {
            if (res?.action !== "logout") {
                return;
            }
            if (frameWindow?.altenarSportsBook) {
                frameWindow.altenarWSDK.set({token: ""});
            } else {
                frameWindow?.location.replace("about:blank");
            }
        });
        return () => {
            authSubscription.unsubscribe();
            frameWindow?.altenarSportsBook?.remove();
        };
    }, [state.game])

    useEffect(() => {
        const onFullscreenChange = () => setFullscreen(!!document.fullscreenElement);
        document.addEventListener("fullscreenchange", onFullscreenChange);
        return () => document.removeEventListener("fullscreenchange", onFullscreenChange);
    }, [])

    useEffect(() => {
        if (!fullscreen) {
            return;
        }

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape" && !document.fullscreenElement) {
                setFullscreen(false);
            }
        };

        document.body.style.overflow = "hidden";
        document.addEventListener("keydown", onKeyDown);
        return () => {
            document.body.style.overflow = "";
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [fullscreen])

    const toggleFullscreen = () => {
        if (fullscreen) {
            if (document.fullscreenElement) {
                document.exitFullscreen().catch(() => setFullscreen(false));
            } else {
                setFullscreen(false);
            }
            return;
        }

        const stage = stageRef.current;
        if (stage && stage.requestFullscreen) {
            stage.requestFullscreen().catch(() => setFullscreen(true));
        } else {
            setFullscreen(true);
        }
    }

    if (state.loading) {
        return (
            <div className={"games-page"}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-auto">
                            <Loading/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    if (!state.game || !state.game.is_active) {
        return (
            <div className={"games-page"}>
                <div className={"container"}>
                    <div className={"games-message"}>
                        <div>Aradığınız oyun bulunamadı.</div>
                        <button className={"button secondary px-4 mt-3"}
                                onClick={() => navigate(paths.games.url)}>
                            Bas Kazan’a Dön
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    const game = state.game;
    const token = Storage.get("token") ?? "";
    const widgetParams = game.vendor === ALTENAR_VENDOR
        ? new URLSearchParams({
            slug: gameSlug(game),
            userToken: token,
            isTest: env.isTest ? "true" : "false",
        })
        : new URLSearchParams({
            token: token,
            vendor: String(game.vendor),
            code: String(game.code),
            userId: String(auth.member?.id ?? ""),
        });
    const widgetUrl = game.vendor === ALTENAR_VENDOR
        ? `${window.location.origin}/altenar-wsdk/altenar-wsdk.html?${widgetParams.toString()}`
        : `${window.location.origin}/game-widget/game-widget.html?${widgetParams.toString()}`;

    return (
        <div className={"games-page game-player-page"}>
            <div className={"container"}>
                <div className={"game-stage" + (fullscreen ? " is-fullscreen" : "")} ref={stageRef}>
                    <div className={"game-player-header"}>
                        <img className={"game-back"} src={iconBack} alt={"geri"}
                             onClick={() => navigate(paths.games.url)}/>
                        <h1 className={"game-player-title"}>{game.name}</h1>
                        <button className={"button primary game-fullscreen"} onClick={toggleFullscreen}>
                            <img className={"game-fullscreen-icon"}
                                 src={fullscreen ? iconExitFullscreen : iconFullscreen} alt={""}/>
                            {fullscreen ? "Tam Ekrandan Çık" : "Tam Ekran"}
                        </button>
                    </div>

                    <iframe
                        ref={frameRef}
                        style={fullscreen ? {width: '100%', flex: 1, minHeight: 0} : undefined}
                        className={"game-frame"} title={game.name} allow={"fullscreen; autoplay"} src={widgetUrl}/>
                </div>

                {game.description && (
                    <div className={"game-info"} dangerouslySetInnerHTML={{
                        __html: String(game.description).replaceAll("\n", "<br/>"),
                    }}/>
                )}
            </div>
        </div>
    )
}
